import { environnement } from "configs/environnement";
import api from "./api";
import {
  IMemberTrainingResponseDTO,
  ISaveMemberTrainingDTO,
  IUpdateMemberTrainingDTO,
} from "models/church.types";

// Base URL alignée sur le RequestMapping (/api/eglise) et le chemin (/v1/member-trainings)
const BASE_URL = `${environnement.baseURL}/member-trainings`;

export const MemberTrainingService = {
  getById: async (id: number): Promise<IMemberTrainingResponseDTO> => {
    const response = await api.get<IMemberTrainingResponseDTO>(
      `${BASE_URL}/${id}`,
    );
    return response.data;
  },

  /**
   * Associer un membre à une formation (Inscription / Suivi)
   * POST /api/eglise/v1/member-trainings
   */
  create: async (
    memberTraining: ISaveMemberTrainingDTO,
  ): Promise<IMemberTrainingResponseDTO> => {
    const response = await api.post<IMemberTrainingResponseDTO>(
      `${BASE_URL}`,
      memberTraining,
    );
    return response.data;
  },

  /**
   * Mettre à jour le suivi d'une formation (Notes, complété, certificat...)
   * PUT /api/eglise/v1/member-trainings
   */
  update: async (
    memberTraining: IUpdateMemberTrainingDTO,
  ): Promise<IMemberTrainingResponseDTO> => {
    const response = await api.put<IMemberTrainingResponseDTO>(
      `${BASE_URL}`,
      memberTraining,
    );
    return response.data;
  },

  /**
   * Supprimer le suivi d'une formation pour un membre
   * DELETE /api/eglise/v1/member-trainings/{id}
   */
  delete: async (id: number): Promise<void> => {
    await api.delete(`${BASE_URL}/${id}`);
  },

  /**
   * Rechercher des suivis de formation (Elasticsearch)
   * Supporte le filtrage optionnel par mot-clé global, par membre spécifique ou par formation spécifique.
   * GET /api/eglise/v1/member-trainings/_search
   */
  search: async (
    page: number,
    size: number,
    filters?: { query?: string; memberId?: number; trainingId?: number },
  ) => {
    const response = await api.get<IMemberTrainingResponseDTO[]>(
      `${BASE_URL}/_search`,
      {
        params: {
          page: page,
          size: size,
          query: filters?.query || undefined,
          memberId: filters?.memberId || undefined,
          trainingId: filters?.trainingId || undefined,
          sort: "lastModifiedDate,desc", // Tri par défaut pour l'affichage professionnel
        },
      },
    );
    return {
      data: response.data,
      totalCount: parseInt(response.headers["x-total-count"] || "0"),
    };
  },
};
